// extracted by mini-css-extract-plugin
export default {"select":"FA7NzOO9U6yQqdII9IUP"};